<template>
  <ion-page class="page-container">
    <TheSidebar />
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar slot="bottom" class="border-gray-200 dark:border-gray-800">
        <ion-tab-button tab="dashboard" href="/dashboard">
          <ion-icon aria-hidden="true" :icon="home" />
          <ion-label>Home</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="recommendations" href="/recommendations">
          <ion-icon aria-hidden="true" :icon="compass" />
          <ion-label>Entdecken</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="settings" href="/settings">
          <ion-icon aria-hidden="true" :icon="settings" />
          <ion-label>Einstellungen</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonLabel,
  IonIcon,
  IonPage,
  IonRouterOutlet,
} from "@ionic/vue";
import { compass, home, notifications, person, settings } from "ionicons/icons";
import TheSidebar from "@/components/TheSidebar.vue";
</script>

<style>
/* Desktop: shift content for sidebar and hide tab bar */
@media (min-width: 1024px) {
  .page-container ion-tab-bar {
    display: none;
  }
}
</style>
